import { AUTH_REQUEST, AUTH_LOADING } from '@/store/actions/auth'
import apiHelper from '@api/helper'

const state = {
  passport: {},
  isLoading: false
}

const getters = {
  passport (state) {
    return state.passport
  },
  authLoading (state) {
    return state.isLoading
  }
}

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, payload) => {
    return new Promise((resolve, reject) => {
      // adding command to set loading : true
      commit(AUTH_LOADING, true)
      dispatch('toggleLoading', true)
      apiHelper.auth.getPassport().then(resp => {
        console.log('---> AUTH_REQUEST:', resp)
        dispatch('toggleLoading', false)
        if (resp.data.responseStatus.responseCode === 'SUCCESS') {
          dispatch('INIT_MENU', resp.data.responseData)
          commit(AUTH_LOADING, false)
          commit(AUTH_REQUEST, resp.data.responseData)
          resolve(resp)
        } else {
          commit(AUTH_LOADING, false)
          reject(resp)
        }
      }).catch(error => {
        console.error('---> AUTH_REQUEST:', error)
        dispatch('toggleLoading', false)
        commit(AUTH_LOADING, false)
        reject(error)
      })
    })
  }
}

const mutations = {
  [AUTH_LOADING]: (state, data) => {
    state.isLoading = data
  },
  [AUTH_REQUEST]: (state, data) => {
    state.passport = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
